<template>
  <v-row>
    <v-col class="mt-2" cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card v-if="userInfo.role === 'HR'" class="mb-5">
        <v-card-title class="theme">
          <v-icon class="white--text" large>calendar_today</v-icon>
          <span class="headline ml-2 white--text">Company calendars</span>
          <v-spacer />
          <span>
            <v-btn
              @click="addCalendarDialog = true"
              depressed
              class="action rounded-sm white--text"
              >add</v-btn
            >
          </span>
        </v-card-title>
        <v-card-text>
          <v-data-table
            :headers="tableHeaders"
            v-if="calendar && calendar.info.list"
            :items="calendar.info.list"
            hide-default-footer
          >
            <template v-slot:[`item.id`]="{ item }">
              <div class="text-right">
                <v-btn
                  class="action mr-2 white--text rounded-sm"
                  @click="preview(item.country_code, item.country_name)"
                  depressed
                  >Edit
                </v-btn>

                <v-btn
                  class="action mr-0 white--text rounded-sm"
                  @click="remove(item)"
                  depressed
                  >Remove
                </v-btn>
              </div>
            </template>
            <template v-slot:no-data>
              <div class="subheading text-xs-center">
                Start with adding a calender for the country you are based in
              </div>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
      <v-card class="mt-2">
        <v-card-title class="theme">
          <v-icon large class="white--text">event</v-icon>
          <span class="headline ml-2 white--text">Calendar events</span>
          <v-spacer />
        </v-card-title>
        <v-sheet height="900">
          <v-calendar
            :value="calendar.today"
            color="primary"
            event-overlap-mode="column"
            :event-color="getColor"
            :event-text-color="getTextColor"
            :weekdays="[1, 2, 3, 4, 5, 6, 0]"
            :event-overlap-threshold="30"
            :events="allevents.events"
            :event-name="getEventName"
            @mouseenter:event="showEvent"
            @mouseleave:event="selectedOpen = false"
          />

          <v-menu
            v-model="selectedOpen"
            :close-on-content-click="false"
            :activator="selectedElement"
            max-width="250"
            offset-y
          >
            <v-card color="grey lighten-4 " width="250px" flat>
              <v-toolbar
                class="elevation-0"
                dark
                dense
                :color="selectedEvent.color"
              >
                <v-spacer v-if="selectedEvent.info.url" />

                <v-toolbar-title
                  class="flex text-center mx-8"
                  v-if="selectedEvent.info.timeoff_type"
                  >{{ selectedEvent.info.timeoff_type }}</v-toolbar-title
                >
                <v-toolbar-title class="flex text-center mx-8" v-else>
                  Holiday
                </v-toolbar-title>
              </v-toolbar>
              <v-list-item>
                <v-list-item-avatar
                  v-if="selectedEvent.info.url"
                  size="75"
                  class="mb-5"
                  style="margin-top: -1rem !important"
                >
                  <v-img :src="selectedEvent.info.url" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-body-2 text-left text-darken2"
                    v-if="selectedEvent.info.user_name"
                    >{{ selectedEvent.info.user_name }}</v-list-item-title
                  >
                  <v-list-item-title
                    class="text-body-2 text-left text-darken2"
                    v-else
                    >{{ selectedEvent.name }}</v-list-item-title
                  >
                  <v-list-item-title
                    class="text-body-2 text-left text-darken2"
                    >{{ selectedEvent.date }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-menu>
        </v-sheet>
        <v-card-actions>
          <v-spacer />
          <v-btn small fab depressed @click="previous">
            <v-icon class="theme-text" left>keyboard_arrow_left</v-icon>
          </v-btn>
          <v-btn small fab depressed @click="next" class="ml-5">
            <v-icon class="theme-text" left>keyboard_arrow_right</v-icon>
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-col>

    <v-dialog v-model="addCalendarDialog" persistent max-width="600px">
      <v-card>
        <v-card-title class="theme">
          <span class="headline white--text"
            >Chose a country to use for calendar</span
          >
          <v-spacer />
          <v-btn icon @click="addCalendarDialog = false">
            <v-icon class="white--text">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-row>
            <v-col cols="8">
              <v-form ref="addCalendar">
                <v-col cols="12">
                  <v-autocomplete
                    label="Pick a country to sync a calendar*"
                    :items="countries"
                    item-text="name"
                    return-object
                    v-model="country"
                    clearable
                    :rules="[validationRules.required]"
                  />
                </v-col>
              </v-form>
            </v-col>
            <v-col cols="5" />
          </v-row>
          <v-btn class="save white--text ml-0" depressed @click="add"
            >save</v-btn
          >
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeDialog" persistent max-width="400px">
      <v-card flat>
        <v-card-title class="my-0">
          <v-spacer />
          <div class="headline text-xs-center">Are you sure?</div>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text class="text-xs-center my-3">
          Confirming this action will remove all the calendar entries for this
          country.
        </v-card-text>
        <v-card-actions>
          <v-btn class="save white--text rounded-sm" depressed @click="unsync"
            >Confirm
          </v-btn>
          <v-spacer />
          <v-btn text @click="removeDialog = false">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="removeEntityDialog" persistent max-width="400px">
      <v-card flat>
        <v-card-title class="my-0">
          <v-spacer />
          <div class="headline text-xs-center">Are you sure?</div>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text class="text-xs-center my-3">
          Confirming this action will remove all the selected calendar entry.
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="removeEntityDialog = false">cancel</v-btn>
          <v-spacer />
          <v-btn
            class="save white--text rounded-sm"
            depressed
            @click="deleteCalendarEntry"
            >Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="editEntryDialog" persistent max-width="500px">
      <v-card flat>
        <v-card-title class="my-0 theme">
          <v-spacer />
          <div class="headline white--text text-xs-center">
            Edit calendar entry
          </div>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text class="text-xs-center my-3">
          <v-form ref="addCalendar">
            <v-col cols="12">
              <v-text-field
                label="Country Name"
                v-model="calEntry.countryName"
                :disabled="true"
              />
              <v-text-field label="Title" v-model="calEntry.title" />
              <v-dialog
                ref="menu1"
                v-model="datePickerModal"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dtfmt"
                    label="Date"
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  v-model="dt"
                  class="mt-0 pt-0"
                  :first-day-of-week="1"
                >
                  <v-btn
                    text
                    small
                    class="theme-text"
                    @click="datePickerModal = false"
                    >Cancel
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    text
                    small
                    class="theme-text"
                    @click="$refs.menu1.save(calEntry.date)"
                    >OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="editEntryDialog = false">cancel</v-btn>
          <v-spacer />
          <v-btn
            class="save white--text rounded-sm"
            depressed
            @click="saveEditForm"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addEntryDialog" persistent max-width="500px">
      <v-card flat>
        <v-card-title class="my-0 theme">
          <v-spacer />
          <div class="headline white--text text-xs-center">
            Add an calendar entry
          </div>
          <v-spacer />
        </v-card-title>
        <v-divider />
        <v-card-text class="text-xs-center my-3">
          <v-form ref="addCalendarEntry">
            <v-col cols="12">
              <v-text-field
                label="Country Name"
                :rules="[validationRules.required]"
                v-model="calEntry.countryName"
                :disabled="true"
              />
              <v-text-field
                label="Title"
                :rules="[validationRules.required]"
                v-model="calEntry.title"
              />
              <v-dialog
                ref="menu2"
                v-model="datePickerModal"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dtfmt"
                    label="Date"
                    v-bind="attrs"
                    v-on="on"
                    :rules="[validationRules.required]"
                  />
                </template>
                <v-date-picker
                  v-model="dt"
                  class="mt-0 pt-0"
                  :first-day-of-week="1"
                >
                  <v-btn
                    text
                    small
                    class="theme-text"
                    @click="datePickerModal = false"
                    >Cancel
                  </v-btn>
                  <v-spacer />
                  <v-btn
                    text
                    small
                    class="theme-text"
                    @click="$refs.menu2.save(calEntry.date)"
                    >OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="addEntryDialog = false">cancel</v-btn>
          <v-spacer />
          <v-btn
            class="save white--text rounded-sm"
            depressed
            @click="saveAddForm"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="previewDialog" persistent max-width="800">
      <v-card>
        <v-card-title class="theme">
          <v-btn icon dark @click="previewDialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title class="white--text"
            >Add or update existing holidays</v-toolbar-title
          >
          <v-spacer />
          <v-btn
            class="action rounded-sm white--text"
            @click="showAddEntryDialog"
          >
            Add Calendar Entry
          </v-btn>
        </v-card-title>
        <v-card-text class="px-0 pb-0">
          <v-data-table
            hide-default-footer
            :options="{ itemsPerPage: 100 }"
            :items="previewItems"
            :headers="previewHeaders"
            fixed-header
          >
            <template v-slot:[`item.id`]="{ item }" class="text-right">
              <v-btn icon class="mr-1">
                <v-icon
                  class="error--text"
                  @click="showDeleteEntityDialog(item)"
                  >delete</v-icon
                >
              </v-btn>
              <v-btn icon @click="showEditEntryDialog(item)">
                <v-icon class="warning--text">edit</v-icon>
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { TableHeaders } from "@/views/headers";

export default {
  name: Component.Protected.Company.Calendar.List,
  data: (vm) => ({
    breadcrumbs: Breadcrumbs.Calendar.List,
    tableHeaders: TableHeaders.Calendar.Calendar,
    addCalendarDialog: false,
    removeDialog: false,
    country: {},
    tempCountryInfo: {},
    search: {
      index: 0,
    },
    selectedEvent: {
      info: {},
    },
    selectedElement: null,
    selectedOpen: false,
    allevents: {
      color: "",
    },
    previewItems: [],
    previewDialog: false,
    previewHeaders: TableHeaders.Calendar.Preview,
    editEntryDialog: false,
    previewCountryCode: "",
    previewCountryName: "",
    id: 0,
    calEntry: {
      title: "",
      date: "",
      countryCode: "",
      countryName: "",
    },
    dt: "", //new Date().toISOString().substr(0, 10),
    dtfmt: "", //vm.ddmmyyyy(new Date().toISOString().substr(0, 10)),
    holidayDateDialog: false,
    datePickerModal: false,
    removeEntityDialog: false,
    addEntryDialog: false,
  }),
  computed: {
    ...mapGetters(["calendar", "countries", "userInfo"]),
  },
  watch: {
    dt(_) {
      this.dtfmt = this.ddmmyyyy(this.dt);
    },
  },
  methods: {
    saveAddForm() {
      if (this.$refs.addCalendarEntry.validate()) {
        let payload = {
          country_code: this.calEntry.countryCode,
          country_name: this.calEntry.countryName,
          title: this.calEntry.title,
          date: this.dtfmt,
        };
        this.$store.dispatch(Actions.Calendar.AddEntry, payload).then((r) => {
          if (r.status === 200) {
            this.preview(this.previewCountryCode, this.previewCountryCode);
            this.addEntryDialog = false;
          }
        });
      }
    },
    showAddEntryDialog() {
      this.calEntry.countryName = this.previewCountryName;
      this.calEntry.countryCode = this.previewCountryCode;
      this.calEntry.title = "";
      this.dt = new Date().toISOString().substring(0, 10);
      this.dtfmt = this.ddmmyyyy(this.dt);
      this.addEntryDialog = true;
    },
    deleteCalendarEntry() {
      if (!this.id) {
        return false;
      }
      this.$store
        .dispatch(Actions.Calendar.DeleteEntry, this.id)
        .then((r) => {
          if (r.status === 200) {
            this.preview(this.previewCountryCode, this.previewCountryName);
          }
        })
        .finally(() => {
          this.removeEntityDialog = false;
          this.id = 0;
        });
    },
    showDeleteEntityDialog(item) {
      if (!item) {
        return false;
      }
      this.id = item.id;
      this.previewCountryCode = item.country_code;
      this.previewCountryName = item.country_name;
      this.removeEntityDialog = true;
    },
    ddmmyyyy(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    saveEditForm() {
      this.calEntry.date = this.dtfmt;

      let payload = {
        id: this.id,
        data: {
          country_code: this.calEntry.countryCode,
          country_name: this.calEntry.countryName,
          title: this.calEntry.title,
          date: this.calEntry.date,
        },
      };
      this.$store
        .dispatch(Actions.Calendar.UpdateEntry, payload)
        .then((r) => {
          if (r.status === 200) {
            this.preview(this.previewCountryCode, this.previewCountryCode);
            this.editEntryDialog = false;
          }
        })
        .finally(() => {
          this.id = 0;
        });
    },
    showEditEntryDialog(item) {
      if (!item) {
        return false;
      }
      this.id = item.id;
      this.calEntry.countryCode = item.country_code;
      this.calEntry.countryName = item.country_name;
      this.calEntry.title = item.title;
      this.dt = item.date.substr(0, 10);
      this.dtfmt = this.ddmmyyyy(item.date.substr(0, 10));
      this.editEntryDialog = true;
    },
    preview(country_code, country_name) {
      this.$store.dispatch(Actions.Calendar.Preview, country_code).then((r) => {
        if (r.status === 200) {
          this.previewItems = r.data;
          this.previewCountryCode = country_code;
          this.previewCountryName = country_name;
          this.previewDialog = true;
        }
      });
    },
    showEvent({ nativeEvent, event }) {
      const open = () => {
        this.selectedEvent = event;
        this.selectedElement = nativeEvent.target;
        setTimeout(() => {
          this.selectedOpen = true;
        }, 10);
      };

      if (this.selectedOpen) {
        this.selectedOpen = false;
        setTimeout(open, 10);
      } else {
        open();
      }

      nativeEvent.stopPropagation();
    },
    getColor(event) {
      switch (event.info.timeoff_type) {
        case "Vacation":
          event.info.timeoff_status === "Approved"
            ? (event.color = "#1D606F")
            : (event.color = "#8aa6ac");
          break;
        case "Sick Leave":
          event.info.timeoff_status === "Approved"
            ? (event.color = "#A23B72")
            : (event.color = "#a2798f");
          break;
        case "Other time off":
          event.info.timeoff_status === "Approved"
            ? (event.color = "#1FA65D")
            : (event.color = "#7ca68f");
          break;
        case "Demo":
          event.info.timeoff_status === "Approved"
            ? (event.color = "#1D606F")
            : (event.color = "#8aa6ac");
          break;
        case "":
          event.color = "#2BB1D0";
          break;
      }
      return event.color;
    },
    getTextColor(event) {
      return event.info.timeoff_status === "Pending" ? "#ecebea" : "white";
    },
    getEventName(event, flag) {
      return event.input.info.timeoff_status === "Pending"
        ? `${event.input.info.user_name} (pending)`
        : !event.input.info.timeoff_status
        ? event.input.name
        : event.input.info.user_name;
    },
    next() {
      this.search.index++;
      this.$store.dispatch(Actions.Calendar.Search, this.search);
    },
    previous() {
      this.search.index--;
      this.$store.dispatch(Actions.Calendar.Search, this.search);
    },
    add() {
      if (this.$refs.addCalendar.validate()) {
        const data = {
          country_code: this.country.code,
          country_name: this.country.name,
        };
        this.$store.dispatch(Actions.Calendar.Sync, data);
        this.addCalendarDialog = false;
      }
    },
    remove(country) {
      this.tempCountryInfo = country;
      this.removeDialog = true;
    },
    unsync() {
      const data = {
        country_code: this.tempCountryInfo.country_code,
        country_name: this.tempCountryInfo.country_name,
      };
      this.$store.dispatch(Actions.Calendar.UnSync, data);
      this.removeDialog = false;
    },
    setup() {
      this.search = { index: 0 };
      this.$store.dispatch(Actions.Calendar.Info);
      this.$store.dispatch(Actions.Calendar.Search, this.search);
      this.allevents = this.calendar;
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>

<style scoped>
* >>> div.v-picker__title {
  background-color: #551738 !important;
  border-color: #551738 !important;
}

* >>> div.v-date-picker-table {
  height: 200px !important;
}
</style>